module.exports = __webpack_public_path__ + "static/media/ble.319b3e9b.svg";